  
<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      v-if="logueado"
    >
      <v-list dense>
        <template v-if="esAdministrador || esConsulta || esCaptura || esSupervisor">
          <v-list-item :to="{name: 'home'}">
            <v-list-item-action>
              <v-icon>home</v-icon>
            </v-list-item-action>
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item>
        </template>
        <template >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>castle</v-icon>Empresas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'empresa'}">
              <v-list-item-action>
                <v-icon>maps_home_work</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Empresas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
           
           
          </v-list-group>
        </template>

        

        <template >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>local_gas_station</v-icon>Liquidacion
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <v-list-item :to="{name: 'turno'}">
              <v-list-item-action>
                <v-icon>folder_open</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Apertura de Turno</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'liquida'}">
              <v-list-item-action>
                <v-icon>face</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Nueva Liquidacion</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'panel'}">
              <v-list-item-action>
                <v-icon>gas_meter</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Panel Liquidacion</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
           
           
          </v-list-group>
        </template>

        <template >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>phone_in_talk</v-icon>Voz
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <v-list-item :to="{name: 'voz'}">
              <v-list-item-action>
                <v-icon>phone_in_talk</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Apertura de por Voz</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          

           
           
          </v-list-group>
        </template>

        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>vpn_key</v-icon>Usuarios
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'usuarios'}">
              <v-list-item-action>
                <v-icon>password</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Usuario</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            
            
          </v-list-group>
        </template>

        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>local_shipping</v-icon>Vehiculos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'vehiculos'}">
              <v-list-item-action>
                <v-icon>directions_car</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Vehiculos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

         <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>airport_shuttle</v-icon>Fletes
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'flete'}">
              <v-list-item-action>
                <v-icon>local_gas_station</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Fletes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <v-list-item :to="{name: 'pipa'}">
              <v-list-item-action>
                <v-icon>local_shipping</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Pipas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

              <v-list-item :to="{name: 'chofer'}">
              <v-list-item-action>
                <v-icon>accessibility_new</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Choferes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <v-list-item :to="{name: 'clientepipa'}">
              <v-list-item-action>
                <v-icon>person_add</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cliente Pipas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <v-list-item :to="{name: 'fleteprecio'}">
              <v-list-item-action>
                <v-icon>money</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Precio de Flete</v-list-item-title>
              </v-list-item-content>
            </v-list-item>


          </v-list-group>
        </template>

        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>contacts</v-icon>Clientes
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'clientes'}">
              <v-list-item-action>
                <v-icon>supervised_user_circle</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Clientes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

        
          </v-list-group>
        </template>

        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>settings</v-icon>Parametros
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'parametro'}">
              <v-list-item-action>
                <v-icon>calendar_month</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Parametros</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'combustible'}">
              <v-list-item-action>
                <v-icon>local_gas_station</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Combustibles</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'isla'}">
              <v-list-item-action>
                <v-icon>oil_barrel</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Islas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'banco'}">
              <v-list-item-action>
                <v-icon>account_balance</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Bancos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

             <v-list-item :to="{name: 'turnonumero'}">
              <v-list-item-action>
                <v-icon>schedule</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Nuevo Turno</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'cierredia'}">
              <v-list-item-action>
                <v-icon>event_busy</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cierre Diario</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-group>
        </template>

        <template v-if="carga || riego ">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>vpn_key</v-icon>Cambio Contraseña
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'cambiocontrasenias'}">
              <v-list-item-action>
                <v-icon>password</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cambio</v-list-item-title>
              </v-list-item-content>
            </v-list-item> 

            
            
          </v-list-group>
        </template>
        
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#000000" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">ADMIN-GAS</span>
      </v-toolbar-title>
      <v-toolbar-title v-if="logueado">Bienvenido: {{$store.state.usuario.usuarionombre}}</v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-toolbar-title v-if="logueado">Fecha: {{getHumanDate($store.state.usuario.fecha)}}</v-toolbar-title>
      <v-btn @click="salir" v-if="logueado" icon>
        <v-icon>logout</v-icon>
      </v-btn>
      <v-btn :to="{name: 'login'}" v-else icon>
        <v-icon>apps</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-content>

    <template>
      <v-footer padless>
        <v-col class="text-center" cols="12" align="center" justify="center">
          <v-avatar>
             
          </v-avatar>

          <strong>Paez Computacion - {{ new Date().getFullYear() }}</strong>
        </v-col>
      </v-footer>
    </template>
  </v-app>
</template>
 

<script>
import moment from "moment";

export default {
  name: "App",
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        {
          icon: "bubble_chart",
          title: "Inspire"
        }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Vuetify.js",
      documentofecha: new Date(),
      avatar: process.env.VUE_APP_CLOUDINARY_URL_AVATAR + "logo.png",
      //date: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
      //  "YYYY-MM-DD"
      //),
      date:new Date(),
    };
  },
  computed: {
    logueado() {
      return this.$store.state.usuario;
    },
    fechasistema(){
      return this.$store.state.usuario.fecha;
    },
    esAdministrador() {
      return (
        this.$store.state.usuario &&
        this.$store.state.usuario.rol == "Administrador"
      );
    },
    esConsulta() {
      return (
        this.$store.state.usuario && this.$store.state.usuario.rol == "Consulta"
      );
    },
    esCaptura() {
      return (
        this.$store.state.usuario && this.$store.state.usuario.rol == "Captura"
      );
    },
    esSupervisor() {
      return (
        this.$store.state.usuario &&
        this.$store.state.usuario.rol == "Supervisor"
      );
    },
    carga() {
      if(this.$store.state.usuario.rolid==1){
         return this.$store.state.usuario.rolid;
      }else{
        return null;
      }
    },
    riego() {
      if(this.$store.state.usuario.rolid==2){
         return this.$store.state.usuario.rolid;
      }else{
        return null;
      }
    }
     

    
  
  },
  created() {
    //this.inicio();
  },
  methods: {
    salir() {
      this.$store.dispatch("salir");
    },
    getHumanDate: function(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    inicio(){  
      this.$swal(this.date);
    }

    
  }
};
</script>

